module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Regular.a82ffb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Regular.svg
// module id = 696
// module chunks = 3